/** The writes the modal's footer can start. A withheld server revision gates all of them. */
export type EventPostModalWrite = 'save' | 'draft' | 'submit' | 'activate' | 'inactivate'

export type EventPostModalUiState = {
  confirmDeleteModalOpen: boolean
  confirmOnCloseModalOpen: boolean
  confirmOnThrowAwayModalOpen: boolean
  confirmOnRemoveAffectedComponentModalOpen: boolean
  confirmSaveEventWithChangeRequest: boolean
  selectedAffectedComponent: number
  openEventEditRequest: boolean
  pendingWrite: EventPostModalWrite | null
}

export type EventPostModalUiAction =
  | {
      type: 'set'
      key: keyof Omit<EventPostModalUiState, 'selectedAffectedComponent' | 'pendingWrite'>
      value: boolean
    }
  | { type: 'setSelectedAffectedComponent'; value: number }
  | { type: 'setPendingWrite'; value: EventPostModalWrite | null }

export const initialEventPostModalUiState: EventPostModalUiState = {
  confirmDeleteModalOpen: false,
  confirmOnCloseModalOpen: false,
  confirmOnThrowAwayModalOpen: false,
  confirmOnRemoveAffectedComponentModalOpen: false,
  confirmSaveEventWithChangeRequest: false,
  selectedAffectedComponent: -1,
  openEventEditRequest: false,
  pendingWrite: null,
}

export function eventPostModalUiReducer(
  state: EventPostModalUiState,
  action: EventPostModalUiAction
): EventPostModalUiState {
  if (action.type === 'setSelectedAffectedComponent') {
    return { ...state, selectedAffectedComponent: action.value }
  }

  if (action.type === 'setPendingWrite') {
    return { ...state, pendingWrite: action.value }
  }

  return {
    ...state,
    [action.key]: action.value,
  }
}
